import React, { memo } from 'react';
import Typography from '@lib/components/Typography/Typography';
import classNames from 'classnames';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import styles from './Message.module.scss';

export enum MessageType {
  blue = 'blue',
  yellow = 'yellow',
}

export interface MessageProps {
  actions?: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  hasBottomSpace?: boolean;
  leftIcon?: string;
  hideLeftLine?: boolean;
  text?: React.ReactNode;
  type?: MessageType;
}

function Message(props: MessageProps) {
  const {
    actions,
    className,
    fullWidth,
    hasBottomSpace = true,
    hideLeftLine = false,
    leftIcon,
    text,
    type = MessageType.blue,
  } = props;
  const hasActions = actions !== undefined;
  const hasLeftIcon = leftIcon !== undefined;
  if (!text) return null;
  const rootClassName = classNames(
    styles.messageRoot,
    {
      [styles.messageRootFullWidth]: fullWidth,
      [styles.messageRootFullBottomPadding]: hasBottomSpace,
    },
    className,
  );
  const messageClassName = classNames(styles.message, styles[type], {
    [styles.withActions]: hasActions,
    [styles.withLeftIcon]: hasLeftIcon,
    [styles.hideLine]: hideLeftLine,
  });
  return (
    <div className={rootClassName}>
      <div className={messageClassName}>
        {hasLeftIcon && (
          <span className={styles.leftIcon}>
            <MaterialIcon icon={leftIcon} />
          </span>
        )}
        <Typography variant="label" block className={styles.messageContent}>
          {text}
        </Typography>
        {hasActions && <span className={styles.actions}>{actions}</span>}
      </div>
    </div>
  );
}

export default memo(Message);
